export default __webpack_public_path__ + "static/media/PR.FREQUENCY.SEVEN_ACTIVITIES_IN_WEEK_ACHIEVED.7cc3cf81.jpg";